import { ReactNode } from 'react';

import { Placeholder } from 'modules/common/components/Placeholder';
import { useAuth } from 'modules/auth/hooks/useAuth';

export interface NoWeb3AuthGuardProps {
  children: ReactNode;
  fallback?: ReactNode;
}

export const NoWeb3AuthGuard = ({
  children,
  fallback = null,
}: NoWeb3AuthGuardProps) => {
  const { isWeb3Auth } = useAuth();

  return (
    <Placeholder hasPlaceholder={isWeb3Auth} placeholder={fallback}>
      {children}
    </Placeholder>
  );
};
